/*
 * Copyright © 2020-2022 Ocean Galaxy Inc. All Rights Reserved.
 * @Description: AI提取loading蒙层组件
 * @LastEditors: jiakaiwen jiakaiwen@huihaiyinhe.com
 * @LastEditTime: 2025-10-27 11:14:53
 */
import React from 'react'
import './AiExtractLoading.scss'

interface IAiExtractLoadingProps {
  visible: boolean
  onCancel: () => void
  loadingText?: string
}

const AiExtractLoading: React.FC<IAiExtractLoadingProps> = ({
  visible,
  onCancel
}) => {
  if (!visible) return null

  const handleCancelClick = (e: React.MouseEvent) => {
    e.preventDefault()
    onCancel()
  }

  return (
    <div className="ai-extract-loading-overlay">
      <div className="ai-extract-loading-content">
        <span className="ai-extract-spinner" aria-label="加载中" />
        <div className="loading-text">
          <span className="loading-text-default">正在加载，点击可</span>
          <span className="loading-text-cancel" onClick={handleCancelClick}>
            取消加载
          </span>
          <span className="loading-text-default">...</span>
        </div>
      </div>
    </div>
  )
}

export default AiExtractLoading
